const punchoutAPI = {
  tags: [
    {
      "name": "punchout",
      "x-displayName": "Punchout",
      "description": "API used for punchout between our app and other supported marketplaces"
    }
  ],
  paths: {
    "punchout/init": {
      post: {
        tags: [
          "punchout"
        ],
        summary: "Incoming Punchout",
        description: "For initiating external user to shopping in sourcesage's marketplace",
        requestBody: {
          content: {
            'application/x-www-form-urlencoded': {
              schema: {
                type: "object",
                required: [
                  'env', 'data'
                ],
                properties: {
                  env: {
                    type: 'string',
                    "description": "Indicates the type of Environtment.",
                    "required": true,
                    "examples": ["production", "development"]
                  },
                  data: {
                    type: 'string',
                    description: 'A string of XML. The example for XML can be found if you change the payload content-type to application/xml',
                    required: true,
                    example: `b'<?xml version="1.0" encoding="UTF-8"?>\\n<!DOCTYPE cXML SYSTEM "http://xml.cxml.org/schemas/cXML/1.2.014/cXML.dtd">\\n<cXML xml:lang="en-US" payloadid="1661142886.853166@prd767app55.int.coupahost.com" timestamp="2022-08-22T06:34:46+02:00">\\n  <Header>\\n    <From>\\n      <Credential domain="DUNS">\\n        <Identity>shop.sourcesage.co</Identity>\\n      </Credential>\\n    </From>\\n    <To>\\n      <Credential domain="DUNS">\\n        <Identity>se.sourcesage.co</Identity>\\n      </Credential>\\n    </To>\\n    <Sender>\\n      <Credential domain="DUNS">\\n        <Identity>shop.sourcesage.co</Identity>\\n        <SharedSecret>8QfIUVjpE318qsuwBbKafI1l0QvwBfAuhFURq46CG0S6iBkedi4cgmdD1MV5hx1L</SharedSecret>\\n      </Credential>\\n      <UserAgent>Coupa Procurement 1.0</UserAgent>\\n    </Sender>\\n  </Header>\\n  <Request>\\n    <PunchOutSetupRequest operation="create">\\n      <BuyerCookie>058918967b3c183ee062fa34691d1d84</BuyerCookie>\\n      <Extrinsic name="FirstName">Akash</Extrinsic>\\n      <Extrinsic name="LastName">Harsoor</Extrinsic>\\n      <Extrinsic name="UniqueName">SESA659642</Extrinsic>\\n      <Extrinsic name="useremail">akash.harsoor@non.se.com</Extrinsic>\\n      <Extrinsic name="User">SESA659642</Extrinsic>\\n      <Extrinsic name="BusinessUnit">COUPA</Extrinsic>\\n      <BrowserFormPost>\\n        <URL>https://schneider-electric.coupahost.com/punchout/checkout?id=666</URL>\\n      </BrowserFormPost>\\n      <Contact role="endUser">\\n        <Name xml:lang="en-US">SESA659642</Name>\\n        <email>akash.harsoor@non.se.com</Email>\\n      </Contact>\\n      <SupplierSetup>\\n        <URL>https://se.sourcesage.co/dbs/api/v1.0/punchout/init</URL>\\n      </SupplierSetup>\\n      <ShipTo>\\n        <Address isoCountryCode="EG" addressID="EGBDR00003">\\n          <Name xml:lang="en">Schneider Electric Pvt. Ltd.</Name>\\n          <PostalAddress name="default">\\n            <DeliverTo>Akash Harsoor</DeliverTo>\\n            <Street>Industrial District 250 Feddans,, Land Plot 144 D & 144 H, East Robeky,, East Robeky</Street>\\n            <City>Badr</City>\\n            <State/>\\n            <PostalCode>11829</PostalCode>\\n            <Country isoCountryCode="EG">Egypt</Country>\\n          </PostalAddress>\\n          <Email name="default">akash.harsoor@non.se.com</Email>\\n        </Address>\\n      </ShipTo>\\n    </PunchOutSetupRequest>\\n  </Request>\\n</cXML>\\n'`
                  }
                }
              }
            },
            "application/xml": {
              example: `<?xml version="1.0" encoding="UTF-8"?>\n<!DOCTYPE cXML SYSTEM "http://xml.cxml.org/schemas/cXML/1.2.014/cXML.dtd">\n<cXML xml:lang="en-US" payloadid="1661142886.853166@prd767app55.int.coupahost.com" timestamp="2022-08-22T06:34:46+02:00">\n  <Header>\n    <From>\n      <Credential domain="DUNS">\n        <Identity>shop.sourcesage.co</Identity>\n      </Credential>\n    </From>\n    <To>\n      <Credential domain="DUNS">\n        <Identity>se.sourcesage.co</Identity>\n      </Credential>\n    </To>\n    <Sender>\n      <Credential domain="DUNS">\n        <Identity>shop.sourcesage.co</Identity>\n        <SharedSecret>8QfIUVjpE318qsuwBbKafI1l0QvwBfAuhFURq46CG0S6iBkedi4cgmdD1MV5hx1L</SharedSecret>\n      </Credential>\n      <UserAgent>Coupa Procurement 1.0</UserAgent>\n    </Sender>\n  </Header>\n  <Request>\n    <PunchOutSetupRequest operation="create">\n      <BuyerCookie>058918967b3c183ee062fa34691d1d84</BuyerCookie>\n      <Extrinsic name="FirstName">Akash</Extrinsic>\n      <Extrinsic name="LastName">Harsoor</Extrinsic>\n      <Extrinsic name="UniqueName">SESA659642</Extrinsic>\n      <Extrinsic name="useremail">akash.harsoor@non.se.com</Extrinsic>\n      <Extrinsic name="User">SESA659642</Extrinsic>\n      <Extrinsic name="BusinessUnit">COUPA</Extrinsic>\n      <BrowserFormPost>\n        <URL>https://schneider-electric.coupahost.com/punchout/checkout?id=666</URL>\n      </BrowserFormPost>\n      <Contact role="endUser">\n        <Name xml:lang="en-US">SESA659642</Name>\n        <email>akash.harsoor@non.se.com</Email>\n      </Contact>\n      <SupplierSetup>\n        <URL>https://se.sourcesage.co/dbs/api/v1.0/punchout/init</URL>\n      </SupplierSetup>\n      <ShipTo>\n        <Address isoCountryCode="EG" addressID="EGBDR00003">\n          <Name xml:lang="en">Schneider Electric Pvt. Ltd.</Name>\n          <PostalAddress name="default">\n            <DeliverTo>Akash Harsoor</DeliverTo>\n            <Street>Industrial District 250 Feddans,, Land Plot 144 D & 144 H, East Robeky,, East Robeky</Street>\n            <City>Badr</City>\n            <State/>\n            <PostalCode>11829</PostalCode>\n            <Country isoCountryCode="EG">Egypt</Country>\n          </PostalAddress>\n          <Email name="default">akash.harsoor@non.se.com</Email>\n        </Address>\n      </ShipTo>\n    </PunchOutSetupRequest>\n  </Request>\n</cXML>`
            }
          },
          "required": true,
        },
        "responses": {
          "200": {
            "description": "Success.",
            "content": {
              "application/xml": {
                example: `<?xml version="1.0" encoding="UTF-8"?>\n<!DOCTYPE cXML SYSTEM "http://xml.cxml.org/schemas/cXML/1.2.014/cXML.dtd">\n<cXML xml:lang="en-US" payloadid="1661142886.853166@prd767app55.int.coupahost.com" timestamp="2022-08-22T06:34:46+02:00">\n  <Header>\n    <From>\n      <Credential domain="DUNS">\n        <Identity>shop.sourcesage.co</Identity>\n      </Credential>\n    </From>\n    <To>\n      <Credential domain="DUNS">\n        <Identity>se.sourcesage.co</Identity>\n      </Credential>\n    </To>\n    <Sender>\n      <Credential domain="DUNS">\n        <Identity>shop.sourcesage.co</Identity>\n        <SharedSecret>8QfIUVjpE318qsuwBbKafI1l0QvwBfAuhFURq46CG0S6iBkedi4cgmdD1MV5hx1L</SharedSecret>\n      </Credential>\n      <UserAgent>Coupa Procurement 1.0</UserAgent>\n    </Sender>\n  </Header>\n  <Request>\n    <PunchOutSetupRequest operation="create">\n      <BuyerCookie>058918967b3c183ee062fa34691d1d84</BuyerCookie>\n      <Extrinsic name="FirstName">Akash</Extrinsic>\n      <Extrinsic name="LastName">Harsoor</Extrinsic>\n      <Extrinsic name="UniqueName">SESA659642</Extrinsic>\n      <Extrinsic name="useremail">akash.harsoor@non.se.com</Extrinsic>\n      <Extrinsic name="User">SESA659642</Extrinsic>\n      <Extrinsic name="BusinessUnit">COUPA</Extrinsic>\n      <BrowserFormPost>\n        <URL>https://schneider-electric.coupahost.com/punchout/checkout?id=666</URL>\n      </BrowserFormPost>\n      <Contact role="endUser">\n        <Name xml:lang="en-US">SESA659642</Name>\n        <email>akash.harsoor@non.se.com</Email>\n      </Contact>\n      <SupplierSetup>\n        <URL>https://se.sourcesage.co/dbs/api/v1.0/punchout/init</URL>\n      </SupplierSetup>\n      <ShipTo>\n        <Address isoCountryCode="EG" addressID="EGBDR00003">\n          <Name xml:lang="en">Schneider Electric Pvt. Ltd.</Name>\n          <PostalAddress name="default">\n            <DeliverTo>Akash Harsoor</DeliverTo>\n            <Street>Industrial District 250 Feddans,, Land Plot 144 D & 144 H, East Robeky,, East Robeky</Street>\n            <City>Badr</City>\n            <State/>\n            <PostalCode>11829</PostalCode>\n            <Country isoCountryCode="EG">Egypt</Country>\n          </PostalAddress>\n          <Email name="default">akash.harsoor@non.se.com</Email>\n        </Address>\n      </ShipTo>\n    </PunchOutSetupRequest>\n  </Request>\n</cXML>`
              }
            }
          },
          "400": {
            "description": "Bad Request"
          }
        }
      },
    },
    "punchout/login": {
      post: {
        tags: [
          "punchout"
        ],
        summary: "Login for Punchout",
        description: "For login punchout",
        produces: [
          'application/json'
        ],
        requestBody: {
          content: {
            'application/json': {
              schema: {
                type: "object",
                required: [
                  'token'
                ],
                properties: {
                  token: {
                    type: 'string',
                    "description": "Special Token",
                    "required": true,
                    "example": "rfpzVqhDhb20K6PWGygP"
                  },
                }
              }
            },
          },
          "required": true,
        },
        responses: {
          "200": {
            "description": "Success.",
            "content": {
              "application/json": {
                schema: {
                  type: 'object',
                  properties: {
                    ok: {
                      type: 'object',
                      description: 'Object that contain punchout_session_id and punchout_country_code',
                      example: {
                        punchout_session_id: 68,
                        punchout_country_code: 'SG'
                      }
                    }
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad Request"
          }
        }
      },
    },
    "punchout/checkout/{punchout_session_id}": {
      post: {
        tags: [
          "punchout"
        ],
        summary: "Checkout Punchout",
        description: "Checkout selected products in cart page",
        produces: [
          'application/json'
        ],
        parameters: [
          {
          name: 'punchout_session_id',
          in: 'path',
          description: 'Punchout session ID that obtained from punchout login API',
          required: true,
          schema: {
            type: 'integer',
            example: 68
          }}
        ],
        requestBody: {
          content: {
            'application/json': {
              schema: {
                type: "object",
                properties: {
                  env: {
                    type: 'string',
                    description: "Environtment of punchout",
                    enum: [
                      'production',
                      'development'
                    ],
                    example: "production"
                  },
                  operation: {
                    type: 'string',
                    example: '[marketplace punchout checkout]'
                  },
                  data: {
                    type: 'string',
                    description: 'A String of xml, the example can also be found if you change the request body schema to application/xml',
                    example: `<?xml version="1.0"?>\r\n<!DOCTYPE cXML SYSTEM "http://xml.cxml.org/schemas/cXML/1.2.008/cXML.dtd">\r\n<cXML payloadid="2022-08-23t09:35:37+10:00.54f7a606093d4dd1b9a30ee231bac6fb.8541931@aeapwmappb2b38.ce.corp" timestamp="2022-08-23T09:35:37+10:00" xml:lang="en">\r\n  <Header>\r\n    <From>\r\n      <Credential domain="DUNS">\r\n        <Identity>750412066</Identity>\r\n      </Credential>\r\n    </From>\r\n    <To>\r\n      <Credential domain="NetworkID">\r\n        <Identity>b2b-tce</Identity>\r\n      </Credential>\r\n    </To>\r\n    <Sender>\r\n      <Credential domain="NetworkID">\r\n        <Identity>750412066</Identity>\r\n      </Credential>\r\n      <UserAgent>Netxpress Shopping Session Exit Response, Corporate Express Australia</UserAgent>\r\n    </Sender>\r\n  </Header>\r\n  <Message>\r\n    <Status code="200" text="OK" xml:lang="en">The shopping session completed successfully.</Status>\r\n    <PunchOutOrderMessage>\r\n      <BuyerCookie>eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzZXNzaW9uX2lkIjo2NDh9.PnZXz8EAPe1FfY7-ZtXZsWajOHgUHRgLRPJhxZfUXQA</BuyerCookie>\r\n      <PunchOutOrderMessageHeader operationAllowed="edit">\r\n        <Total>\r\n          <Money currency="AUD">199.30</Money>\r\n        </Total>\r\n      </PunchOutOrderMessageHeader>\r\n      <ItemIn quantity="5" lineNumber="1">\r\n        <ItemID>\r\n          <SupplierPartID>18915891</SupplierPartID>\r\n        </ItemID>\r\n        <ItemDetail>\r\n          <UnitPrice>\r\n            <Money currency="AUD">18.64</Money>\r\n          </UnitPrice>\r\n          <Description xml:lang="en">3M Vv848 Visor Polycarbonate 1mm Clear High Impact 200mm X 300mm Each</Description>\r\n          <UnitOfMeasure>EA</UnitOfMeasure>\r\n          <Classification domain="UNSPSC">46181700</Classification>\r\n          <ManufacturerName></ManufacturerName>\r\n        </ItemDetail>\r\n        <Tax>\r\n          <Money currency="AUD">9.30</Money>\r\n          <Description xml:lang="en">GST</Description>\r\n        </Tax>\r\n      </ItemIn>\r\n      <ItemIn quantity="5" lineNumber="2">\r\n        <ItemID>\r\n          <SupplierPartID>87022408</SupplierPartID>\r\n        </ItemID>\r\n        <ItemDetail>\r\n          <UnitPrice>\r\n            <Money currency="AUD">17.60</Money>\r\n          </UnitPrice>\r\n          <Description xml:lang="en">3M Visor Holder</Description>\r\n          <UnitOfMeasure>EA</UnitOfMeasure>\r\n          <Classification domain="UNSPSC">46181700</Classification>\r\n          <ManufacturerName></ManufacturerName>\r\n        </ItemDetail>\r\n        <Tax>\r\n          <Money currency="AUD">8.80</Money>\r\n          <Description xml:lang="en">GST</Description>\r\n        </Tax>\r\n      </ItemIn>\r\n    </PunchOutOrderMessage>\r\n  </Message>\r\n</cXML>`
                  },
                  payload: {
                    type: 'object',
                    description: 'Object that contain cXML',
                    example: {
                      cXML: {
                        "@payloadID": "2022-08-23t09:35:37+10:00.54f7a606093d4dd1b9a30ee231bac6fb.8541931@aeapwmappb2b38.ce.corp",
                        "@timestamp": "2022-08-23T09:35:37+10:00",
                        "@xml:lang": "en",
                        "Header": {
                          "From": {
                            "Credential": {
                              "@domain": "DUNS",
                              "Identity": "750412066"
                            }
                          },
                          "To": {
                            "Credential": {
                              "@domain": "NetworkID",
                              "Identity": "b2b-tce"
                            }
                          },
                          "Sender": {
                            "Credential": {
                              "@domain": "NetworkID",
                              "Identity": "750412066"
                            },
                            "UserAgent": "Netxpress Shopping Session Exit Response, Corporate Express Australia"
                          }
                        },
                        "Message": {
                          "Status": {
                            "@code": "200",
                            "@text": "OK",
                            "@xml:lang": "en",
                            "#text": "The shopping session completed successfully."
                          },
                          "PunchOutOrderMessage": {
                            "BuyerCookie": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzZXNzaW9uX2lkIjo2NDh9.PnZXz8EAPe1FfY7-ZtXZsWajOHgUHRgLRPJhxZfUXQA",
                            "PunchOutOrderMessageHeader": {
                              "@operationAllowed": "edit",
                              "Total": {
                                "Money": {
                                  "@currency": "AUD",
                                  "#text": "199.30"
                                }
                              }
                            },
                            "ItemIn": [
                              {
                                "@quantity": "5",
                                "@lineNumber": "1",
                                "ItemID": {
                                  "SupplierPartID": "18915891"
                                },
                                "ItemDetail": {
                                  "UnitPrice": {
                                    "Money": {
                                      "@currency": "AUD",
                                      "#text": "18.64"
                                    }
                                  },
                                  "Description": {
                                    "@xml:lang": "en",
                                    "#text": "3M Vv848 Visor Polycarbonate 1mm Clear High Impact 200mm X 300mm Each"
                                  },
                                  "UnitOfMeasure": "EA",
                                  "Classification": {
                                    "@domain": "UNSPSC",
                                    "#text": "46181700"
                                  },
                                  "ManufacturerName": null
                                },
                                "Tax": {
                                  "Money": {
                                    "@currency": "AUD",
                                    "#text": "9.30"
                                  },
                                  "Description": {
                                    "@xml:lang": "en",
                                    "#text": "GST"
                                  }
                                }
                              },
                              {
                                "@quantity": "5",
                                "@lineNumber": "2",
                                "ItemID": {
                                  "SupplierPartID": "87022408"
                                },
                                "ItemDetail": {
                                  "UnitPrice": {
                                    "Money": {
                                      "@currency": "AUD",
                                      "#text": "17.60"
                                    }
                                  },
                                  "Description": {
                                    "@xml:lang": "en",
                                    "#text": "3M Visor Holder"
                                  },
                                  "UnitOfMeasure": "EA",
                                  "Classification": {
                                    "@domain": "UNSPSC",
                                    "#text": "46181700"
                                  },
                                  "ManufacturerName": null
                                },
                                "Tax": {
                                  "Money": {
                                    "@currency": "AUD",
                                    "#text": "8.80"
                                  },
                                  "Description": {
                                    "@xml:lang": "en",
                                    "#text": "GST"
                                  }
                                }
                              }
                            ]
                          }
                        }
                      }
                    }
                  }
                }
              }
            },
            'application/xml': {
              example: `<?xml version="1.0"?>\r\n<!DOCTYPE cXML SYSTEM "http://xml.cxml.org/schemas/cXML/1.2.008/cXML.dtd">\r\n<cXML payloadid="2022-08-23t09:35:37+10:00.54f7a606093d4dd1b9a30ee231bac6fb.8541931@aeapwmappb2b38.ce.corp" timestamp="2022-08-23T09:35:37+10:00" xml:lang="en">\r\n  <Header>\r\n    <From>\r\n      <Credential domain="DUNS">\r\n        <Identity>750412066</Identity>\r\n      </Credential>\r\n    </From>\r\n    <To>\r\n      <Credential domain="NetworkID">\r\n        <Identity>b2b-tce</Identity>\r\n      </Credential>\r\n    </To>\r\n    <Sender>\r\n      <Credential domain="NetworkID">\r\n        <Identity>750412066</Identity>\r\n      </Credential>\r\n      <UserAgent>Netxpress Shopping Session Exit Response, Corporate Express Australia</UserAgent>\r\n    </Sender>\r\n  </Header>\r\n  <Message>\r\n    <Status code="200" text="OK" xml:lang="en">The shopping session completed successfully.</Status>\r\n    <PunchOutOrderMessage>\r\n      <BuyerCookie>eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzZXNzaW9uX2lkIjo2NDh9.PnZXz8EAPe1FfY7-ZtXZsWajOHgUHRgLRPJhxZfUXQA</BuyerCookie>\r\n      <PunchOutOrderMessageHeader operationAllowed="edit">\r\n        <Total>\r\n          <Money currency="AUD">199.30</Money>\r\n        </Total>\r\n      </PunchOutOrderMessageHeader>\r\n      <ItemIn quantity="5" lineNumber="1">\r\n        <ItemID>\r\n          <SupplierPartID>18915891</SupplierPartID>\r\n        </ItemID>\r\n        <ItemDetail>\r\n          <UnitPrice>\r\n            <Money currency="AUD">18.64</Money>\r\n          </UnitPrice>\r\n          <Description xml:lang="en">3M Vv848 Visor Polycarbonate 1mm Clear High Impact 200mm X 300mm Each</Description>\r\n          <UnitOfMeasure>EA</UnitOfMeasure>\r\n          <Classification domain="UNSPSC">46181700</Classification>\r\n          <ManufacturerName></ManufacturerName>\r\n        </ItemDetail>\r\n        <Tax>\r\n          <Money currency="AUD">9.30</Money>\r\n          <Description xml:lang="en">GST</Description>\r\n        </Tax>\r\n      </ItemIn>\r\n      <ItemIn quantity="5" lineNumber="2">\r\n        <ItemID>\r\n          <SupplierPartID>87022408</SupplierPartID>\r\n        </ItemID>\r\n        <ItemDetail>\r\n          <UnitPrice>\r\n            <Money currency="AUD">17.60</Money>\r\n          </UnitPrice>\r\n          <Description xml:lang="en">3M Visor Holder</Description>\r\n          <UnitOfMeasure>EA</UnitOfMeasure>\r\n          <Classification domain="UNSPSC">46181700</Classification>\r\n          <ManufacturerName></ManufacturerName>\r\n        </ItemDetail>\r\n        <Tax>\r\n          <Money currency="AUD">8.80</Money>\r\n          <Description xml:lang="en">GST</Description>\r\n        </Tax>\r\n      </ItemIn>\r\n    </PunchOutOrderMessage>\r\n  </Message>\r\n</cXML>`
            }
          }
        }
      },
    },
    "/punchout/outgoing/init": {
      post: {
        tags: [
          "punchout"
        ],
        summary: "Outgoing Punchout",
        description: "For initiating punchout to other marketplace",
        produces: [
          "application/json"
        ],
        requestBody: {
          content: {
            'application/json': {
              schema: {
                type: 'object',
                required: ['marketplace_punchout_vendor_id'],
                properties: {
                  marketplace_punchout_vendor_id: {
                    type: 'integer',
                    description: 'External marketplace vendor id',
                    example: 68
                  }
                }
              }
            }
          }
        },
        responses: {
          "200": {
            "description": "Success.",
            "content": {
              "application/json": {
                schema: {
                  type: 'object',
                  properties: {
                    redirect_url: {
                      type: 'string',
                      description: 'redirect_url to start punching out on other marketplace',
                      example: 'https://somedomain.com/marketplace?punchout_session_id=123kj12481230u'
                    }
                  }
                }
              }
            }
          },
          "400": {
            "description": "Bad Request"
          }
        }
      }
    },
    "/punchout/outgoing/checkout": {
      "post": {
        "tags": [
          "punchout"
        ],
        "summary": "Checkout Outgoing Punchout",
        "description": "For checkout with selected products in the cart on other marketplaces",
        "produces": [
          "application/json"
        ],
      }
    }
  }
}

export default punchoutAPI